<template>
    <router-view/>
</template>
<script>
export default {
    watch: {
        '$route.params.catalogueId': function (catalogueId) {
            if (catalogueId) {
                this.$store.dispatch('projects/project/extension/catalogue/setCatalogueId', catalogueId)
            }
        }
    },
    beforeMount() {
        const {catalogueId} = this.$route.params;
        if (catalogueId) {
            this.$store.dispatch('projects/project/extension/catalogue/setCatalogueId', catalogueId)
        }
    }
}
</script>
